export default __webpack_public_path__ + "static/media/img-palhaco-brincar.dfdfb18e.png";